export default function ($http) {
    return function (pageNumber) {
        var params = {};
        if (pageNumber) {
            params.pageNumber = pageNumber;
        }

        return $http.get('api/users/', { params }).then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/admin/users/services/list/getUsers.js